export const PRODUIT_PRESSE = {
  encarts: {
    actions: {
      add: 'Ajouter un encart',
      dupliquer: 'Dupliquer',
      supprimer: 'Supprimer',
      archiver: 'Archiver',
      desarchiver: 'Désarchiver',
      appliquerFormatPresse: 'Appliquer un type de format presse',
      displayEncartInactif: 'Afficher les encarts inactifs ({number})',
      masquerEncartInactif: 'Masquer les encarts inactifs ({number})',
      categorieOperation: 'Appliquer une catégorie d\'opération',
    },
    tab: {
      reference: 'Code',
      libelle: 'Libellé',
      libelleComplementaire: 'Libellé compl.',
      surface: 'Surface',
      emplacement: 'Emplacement',
      couleurEncart: 'Couleur',
      format: 'Format',
      largeur: 'Largeur (mm)',
      hauteur: 'Hauteur (mm)',
      dateDebut: 'Date début',
      dateFin: 'Date fin',
      prixUnitaire: 'P.U',
      actif: 'Actif',
      categorieOperation: 'Catégorie opération',
      tauxTva: '% TVA',
    },
    popUpFormatPresse: {
      title: 'Appliquer un type de format presse',
      typeFormatPresse: 'Type format presse',
    },
    popUpCategorieOperation: {
      title: 'Appliquer une catégorie d\'opération',
      categorieOperation: 'Catégorie d\'opération',
    },
    popUpDuplication: {
      title: 'Dupliquer des encarts',
      label: 'Nombre de duplication',
    },
  },
  errors: {
    dateDebut: 'Date début encart',
    libelle: 'Libelle encart',
    surface: 'Surface encart',
    emplacement: 'Emplacement encart',
    couleur: 'Couleur encart',
  },
  formatProduit: {
    title: 'Format du produit',
    largeurPleinPapier: 'Largeur plein papier (mm)',
    hauteurPleinPapier: 'Hauteur plein papier (mm)',
    largeurFormatUtile: 'Largeur format utile (mm)',
    hauteurFormatUtile: 'Hauteur format utile (mm)',
    margeHaut: 'Marge haut (mm)',
    margeGauche: 'Marge gauche (mm)',
    periodicite: 'Périodicité (mm)',
    typeFormatPresse: 'Type de format (mm)',
  },
  prestationGracieuse: {
    title: 'Prestations gracieuses',
  },
  modeDistribution: 'Mode de distribution',
  nbTirage: 'Nombre de tirage',
  controleDisponibilite: 'Contrôle sur la disponibilité',
  renouvelable: 'Renouvelable',
};

export const AJOUT_PRESSE_DCF = {
  title: 'Ajouter un produit presse',
  brief: 'Mon brief',
  panier: 'Panier',
  table: {
    code: 'Code presse',
    libelle: 'Libellé',
    societe: 'Société',
    dateDebut: 'Date de début',
    dateFin: 'Date de fin',
    typeProduit: 'Type de produit',
  },
  popupSelection: {
    encart: 'Encarts',
    selectionEncart: 'Sélectionner un encart pour le produit presse',
    produitAssocie: 'Produits associés',
    selectionProduitAssocie: 'Sélectionner des produits associés pour le produit presse',
    parutions: 'Parutions',
    selectionParution: 'Sélectionner une parution pour le produit presse',
    addInCart: 'Ajouter au panier',
    du: 'Du',
    au: 'au',
  },
  briefContent: {
    libelle: 'Libellé',
    societe: 'Société',
    code: 'Code',
  },
  etatBat: {
    demandeVisuel: 'Demande du visuel',
    envoieBat: 'Envoi du BAT',
    attenteRetourBat: 'Attente retour du BAT',
    batSigne: 'BAT signé',
    transmisPAO: 'Transmis PAO',
    validationVRP: 'Validation VRP',
  },
};
